import { AxiosRequestConfig } from 'axios';

// For endpoints that do slow work inside the request (AI generation,
// third-party lookups). Longer than the default timeout, and never retried
// automatically: the server keeps working after a client timeout, so a retry
// would start the same expensive job again.
export const SLOW_REQUEST_TIMEOUT_MS = 120000;

type RetriableAxiosRequestConfig = AxiosRequestConfig & {
	'axios-retry'?: {
		retries: number;
	};
};

export const slowRequestConfig: RetriableAxiosRequestConfig = {
	timeout: SLOW_REQUEST_TIMEOUT_MS,
	'axios-retry': {
		retries: 0,
	},
};
